module.exports = __webpack_public_path__ + "img/prize-04.9192fad5.png";